import { Button, Input, useDisclosure } from '@heroui/react'
import React, { useEffect, useState } from 'react'
import Notiflix from "notiflix";
import ForgotPasswordModel from '../components/common/ForgotPasswordModel';

const Login = () => {

  const BASE_URL = "https://oxfordcollege.lk/api/"
  const END_POINT = BASE_URL + "routes/";

  const checkAuth = async () => {
    const response = await fetch(END_POINT + 'auth.php?route=check', {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${document.cookie.split('jwt=')[1]?.split(';')[0]}`
      }
    });
    const respData = await response.json();

    if (respData.status === 200 && !respData.data.isExpired) {
      if (respData.data.role === 'student') {
        document.location = 'https://portal.oxfordcollege.lk/view';
      }
    }

  }

  useEffect(() => {
    checkAuth();
  }, [])

  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const [formData, setFormData] = useState({
    registrationNumber: '',
    email: '',
    password: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async () => {
    Notiflix.Loading.pulse('Logging in...');

    if (formData.email === '' || formData.password === '') {
      Notiflix.Loading.remove();
      Notiflix.Notify.failure('Please fill all the required fields');
      return;
    }

    try {
      let bearer = '';
      if (document.cookie.split('jwt=')[1]) {
        bearer = `Bearer ${document.cookie.split('jwt=')[1]?.split(';')[0]}`;
      }
      const response = await fetch(END_POINT + 'auth.php?route=login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${bearer}`
        },
        body: JSON.stringify(formData),
      });
      const respData = await response.json();

      if (!response.ok || respData.status !== 200) {
        Notiflix.Loading.remove();
        Notiflix.Notify.failure('Login failed');
        return;
      }

      document.cookie = `jwt=${respData.jwt}; max-age=${60 * 60 * 24 * 2}`;

      checkAuth();

      Notiflix.Loading.remove();
      Notiflix.Notify.success('Login successful');
    } catch (error) {
      console.error("Error logging in : ", error);
    }
  }

  return (
    <div className='my-10 grid grid-cols-1 md:grid-cols-2 gap-4 items-center'>
      <div className='col-span-1 relative'>
        <div className='bg-neutral-100 w-full h-[250px] md:rounded-tr-2xl md:rounded-br-2xl absolute bottom-0 left-0 -z-10'></div>
        <img src="./assets/images/login-left.png" alt="" className='w-full h-[400px] object-contain object-bottom' />
      </div>

      <div className='col-span-1 flex flex-col text-center gap-y-4 px-10'>
        <h3 className='font-bebas text-5xl uppercase'>Get Your Access</h3>
        <Input variant='faded' isRequired label="Registration Number" placeholder="Enter your registration number" type="text" name="registrationNumber" value={formData.registrationNumber} onChange={handleChange} />
        <Input variant='faded' isRequired label="Email" placeholder="Enter your email" type="email" name="email" value={formData.email} onChange={handleChange} />
        <Input variant='faded' isRequired label="Password" placeholder="Enter your password" type="password" name="password" value={formData.password} onChange={handleChange} />
        <span className='text-neutral-400 text-sm underline bg-transparent border-none cursor-pointer' onClick={onOpen}>Forgot Password?</span>
        <Button className='mt-5 bg-primary-blue text-white w-fit mx-auto' radius='sm' onPress={handleSubmit}>Login</Button>
        <ForgotPasswordModel isOpen={isOpen} onOpenChange={onOpenChange} />
      </div>
    </div>
  )
}

export default Login